// Read from environment variables with fallback defaults
const baseUrl = import.meta.env.VITE_API_BASE_URL || "http://localhost:8080/";
const baseUrlRes1 = baseUrl;
const twilioUrl = baseUrl || "http://localhost:8080/";
const cloudinaryUrl = import.meta.env.VITE_CLOUDINARY_URL || "https://cloudinary-multer.onrender.com";

export { baseUrl, baseUrlRes1, cloudinaryUrl, twilioUrl };